const LOCAL_BROWSER_URL = 'https://localhost:5173'
const DEV_BROWSER_URL = 'https://testbot.podpiska.vip'
const PROD_BROWSER_URL = 'https://bot.podpiska.vip'

const LOCAL_TELEGRAM_REGISTER_WEBAPP_URL =
  'https://t.me/noproblemvpn_test_bot?start=register_webapp'
const DEV_TELEGRAM_REGISTER_WEBAPP_URL =
  'https://t.me/noproblemvpn_test_bot?start=register_webapp'
const PROD_TELEGRAM_REGISTER_WEBAPP_URL =
  'https://t.me/vpn_noproblem_bot?start=register_webapp'

type KnownBranch = 'local' | 'develop' | 'master'

const resolveBranch = (): KnownBranch => {
  const raw =
    (import.meta.env.VITE_GIT_BRANCH as string | undefined) ??
    (import.meta.env.VITE_SENTRY_ENVIRONMENT as string | undefined) ??
    import.meta.env.MODE

  const branch = raw?.toLowerCase() ?? 'local'

  if (branch.includes('master') || branch.includes('prod')) {
    return 'master'
  }

  if (
    branch.includes('develop') ||
    branch.includes('dev') ||
    branch.includes('test')
  ) {
    return 'develop'
  }

  return 'local'
}

const branchUrlMap: Record<KnownBranch, string> = {
  local: LOCAL_BROWSER_URL,
  develop: DEV_BROWSER_URL,
  master: PROD_BROWSER_URL
}

const telegramRegisterWebappUrlMap: Record<KnownBranch, string> = {
  local: LOCAL_TELEGRAM_REGISTER_WEBAPP_URL,
  develop: DEV_TELEGRAM_REGISTER_WEBAPP_URL,
  master: PROD_TELEGRAM_REGISTER_WEBAPP_URL
}

/**
 * Основной URL для входа через браузер.
 * Можно переопределить через переменную окружения VITE_BROWSER_LOGIN_URL.
 */
export const BROWSER_LOGIN_URL =
  import.meta.env.VITE_BROWSER_LOGIN_URL ??
  branchUrlMap[resolveBranch()]

export const BROWSER_LOGIN_URL_LOCAL = LOCAL_BROWSER_URL
export const BROWSER_LOGIN_URL_DEV = DEV_BROWSER_URL
export const BROWSER_LOGIN_URL_PROD = PROD_BROWSER_URL

/**
 * Ссылка на Telegram Web App для заполнения данных входа.
 * Можно переопределить через переменную окружения VITE_TELEGRAM_REGISTER_WEBAPP_URL.
 */
export const TELEGRAM_REGISTER_WEBAPP_URL =
  import.meta.env.VITE_TELEGRAM_REGISTER_WEBAPP_URL ??
  telegramRegisterWebappUrlMap[resolveBranch()]


